import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export interface Feature {
  icon: LucideIcon;
  title: string;
  text: string;
}

const FeatureStrip = ({ features, className }: { features: Feature[]; className?: string }) => {
  return (
    <ul className={cn("grid gap-8 rounded-2xl bg-mint p-7 sm:p-9 md:grid-cols-3 md:gap-0", className)}>
      {features.map(({ icon: Icon, title, text }) => (
        <li
          key={title}
          className="md:border-l md:border-brand/25 md:px-8 md:first:border-l-0 md:first:pl-0 md:last:pr-0"
        >
          <Icon className="size-8 text-brand-ink" strokeWidth={1.75} aria-hidden />
          <h3 className="mt-4 font-semibold text-navy">{title}</h3>
          <p className="mt-1 text-[15px] leading-relaxed text-slate-600">{text}</p>
        </li>
      ))}
    </ul>
  );
};

export default FeatureStrip;
